import { CustomEventWithDetail, html, View } from 'rune-ts';
import { ButtonFilter } from '../../../atoms/ButtonFilter/ButtonFilter';

export class ProductFilterButtonClickEvent extends CustomEventWithDetail<{
  id: number | string;
  is_active: boolean;
}> {}

export interface ProductFilterButtonData {
  id: number | string;
  name: string;
}

export class ProductFilterButton extends View<ProductFilterButtonData> {
  constructor(
    data: ProductFilterButtonData,
    private option: { is_active?: boolean; klass?: string } = {},
  ) {
    super(data, option);
  }

  override template() {
    const { name } = this.data;
    const { klass: custom_klass = '', is_active } = this.option;
    return html`<div>${new ButtonFilter({ label: name, is_active, klass: custom_klass ?? '' })}</div>`;
  }

  override onRender() {
    this.delegate('click', ButtonFilter, (_e, view) => {
      this.dispatchEvent(ProductFilterButtonClickEvent, {
        bubbles: true,
        detail: {
          id: this.data.id,
          is_active: view.data.is_active ?? false,
        },
      });
    });
  }
}
